function f(e,...t){return(...r)=>e(...r,...t)}export{f as a};
